/** @format */

export const XLarge = ({color}) => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M26.1663 11.4783L24.5213 9.83334L17.9997 16.355L11.478 9.83334L9.83301 11.4783L16.3547 18L9.83301 24.5217L11.478 26.1667L17.9997 19.645L24.5213 26.1667L26.1663 24.5217L19.6447 18L26.1663 11.4783Z"
                fill={color}
            />
            <rect x="1" y="1" width="34" height="34" rx="17" stroke="#323232" stroke-width="2" />
        </svg>
    );
};
